import { connectedStore } from '../../store';
import selectors from '../selectors';

const getUserEmails = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getUserEmails(state);
};

export default getUserEmails;
